import { ReactNode } from 'react'
import { IChildrenProps } from '@/typings/children-props'
import { cn } from '@/utils/styles/cn'

interface ICommonSectionProps extends IChildrenProps {
    titleClassName?: string
    className?: string
    title?: ReactNode | string
}

export const CommonSection = ({
    titleClassName,
    className,
    children,
    title,
}: ICommonSectionProps) => {
    return (
        <div className={cn('flex flex-col items-center justify-center py-24 w-full', className)}>
            {title && (
                <h2
                    className={cn(
                        'leading-[1.5] font-bold text-[32px] md:text-[32px] mb-8 md:mb-8 text-left md:text-left px-4 md-px-0',
                        titleClassName
                    )}
                >
                    {title}
                </h2>
            )}

            {children}
        </div>
    )
}
